import React from 'react';
import { getFileType, getFileIconUrl } from '@cainiaofe/cn-ui-common';
export var StaticFileIcon = function (_a) {
    var className = _a.className, file = _a.file;
    var fileType = getFileType(file);
    var cdnUrl = getFileIconUrl(fileType);
    return (React.createElement("div", { className: className },
        React.createElement("img", { src: cdnUrl })));
};
